import { Component } from '@angular/core';

@Component({
  selector: 'app-page-404',
  standalone: true,
  imports: [],
  templateUrl: './page-404.component.html',
  styleUrls: ['./page-404.component.scss','../../../../auth.scss'],
})
export class Page404Component {}
